var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
export var ScreenSize;
(function (ScreenSize) {
    ScreenSize[ScreenSize["s"] = 668] = "s";
    ScreenSize[ScreenSize["m"] = 1024] = "m";
    ScreenSize[ScreenSize["l"] = 1280] = "l";
    ScreenSize[ScreenSize["xl"] = 1600] = "xl";
    ScreenSize[ScreenSize["oldL"] = 1200] = "oldL";
    ScreenSize[ScreenSize["oldXl"] = 1540] = "oldXl";
})(ScreenSize || (ScreenSize = {}));
export var MediaQuery;
(function (MediaQuery) {
    MediaQuery["fromTablet"] = "FROM_TABLET";
    MediaQuery["fromSmallDesktop"] = "FROM_SMALL_DESKTOP";
    MediaQuery["fromMediumDesktop"] = "FROM_MEDIUM_DESKTOP";
    MediaQuery["fromLargeDesktop"] = "FROM_LARGE_DESKTOP";
    MediaQuery["tabletOnly"] = "TABLET_ONLY";
    MediaQuery["smallDesktopOnly"] = "SMALL_DESKTOP_ONLY";
    MediaQuery["mediumDesktopOnly"] = "MEDIUM_DESKTOP_ONLY";
})(MediaQuery || (MediaQuery = {}));
export var MediaQuerie;
(function (MediaQuerie) {
    /** @deprecated Prefer other Media query for a mobile first implementation */
    MediaQuerie[MediaQuerie["mobile"] = 0] = "mobile";
    /** @deprecated Use fromTablet */
    MediaQuerie[MediaQuerie["mobileOver"] = 1] = "mobileOver";
    /** @deprecated Use tabletOnly */
    MediaQuerie[MediaQuerie["tablet"] = 2] = "tablet";
    /** @deprecated Prefer other Media query for a mobile first implementation */
    MediaQuerie[MediaQuerie["tabletLess"] = 3] = "tabletLess";
    /** @deprecated Prefer other Media query for a mobile first implementation */
    MediaQuerie[MediaQuerie["desktopLess"] = 4] = "desktopLess";
    /** @deprecated Use fromSmallDesktop */
    MediaQuerie[MediaQuerie["desktop"] = 5] = "desktop";
    /** @deprecated Use smallDesktopOnly */
    MediaQuerie[MediaQuerie["laptop"] = 6] = "laptop";
    /** @deprecated Use fromMediumDesktop */
    MediaQuerie[MediaQuerie["desktopHd"] = 7] = "desktopHd";
    /** @deprecated Use fromLargeDesktop */
    MediaQuerie[MediaQuerie["desktopLhd"] = 8] = "desktopLhd";
})(MediaQuerie || (MediaQuerie = {}));
var maxWidth = 'max-width';
var minWidth = 'min-width';
var mediaWidth = (_a = {},
    _a[MediaQuerie.mobile] = (_b = {}, _b[maxWidth] = ScreenSize.s - 1, _b),
    _a[MediaQuerie.mobileOver] = (_c = {}, _c[minWidth] = ScreenSize.s, _c),
    _a[MediaQuerie.tablet] = (_d = {}, _d[minWidth] = ScreenSize.s, _d[maxWidth] = ScreenSize.m, _d),
    _a[MediaQuerie.tabletLess] = (_e = {}, _e[maxWidth] = ScreenSize.m, _e),
    _a[MediaQuerie.desktopLess] = (_f = {}, _f[maxWidth] = ScreenSize.m, _f),
    _a[MediaQuerie.desktop] = (_g = {}, _g[minWidth] = ScreenSize.m + 1, _g),
    _a[MediaQuerie.laptop] = (_h = {}, _h[minWidth] = ScreenSize.m + 1, _h[maxWidth] = ScreenSize.oldL, _h),
    _a[MediaQuerie.desktopHd] = (_j = {}, _j[minWidth] = ScreenSize.oldL + 1, _j),
    _a[MediaQuerie.desktopLhd] = (_k = {}, _k[minWidth] = ScreenSize.oldXl, _k),
    _a[MediaQuery.tabletOnly] = (_l = {}, _l[minWidth] = ScreenSize.s, _l[maxWidth] = ScreenSize.m - 1, _l),
    _a[MediaQuery.smallDesktopOnly] = (_m = {}, _m[minWidth] = ScreenSize.m, _m[maxWidth] = ScreenSize.l - 1, _m),
    _a[MediaQuery.mediumDesktopOnly] = (_o = {}, _o[minWidth] = ScreenSize.l, _o[maxWidth] = ScreenSize.xl - 1, _o),
    _a[MediaQuery.fromTablet] = (_p = {}, _p[minWidth] = ScreenSize.s, _p),
    _a[MediaQuery.fromSmallDesktop] = (_q = {}, _q[minWidth] = ScreenSize.m, _q),
    _a[MediaQuery.fromMediumDesktop] = (_r = {}, _r[minWidth] = ScreenSize.l, _r),
    _a[MediaQuery.fromLargeDesktop] = (_s = {}, _s[minWidth] = ScreenSize.xl, _s),
    _a);
var computeSize = function (size) {
    return Object.entries(mediaWidth[size])
        .map(function (_a) {
        var property = _a[0], width = _a[1];
        return "(" + property + ": " + width + "px)";
    })
        .join(' and ');
};
export var getMQ = function (size) { return "only screen and " + computeSize(size); };
